var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[[_c('SuccessfulPurchase',{attrs:{"installmentSelectedLabel":_vm.label,"paymentType":_vm.paymentType,"upsell":_vm.upsell}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }